import { useTranslation } from 'react-i18next';
import { ICategory } from '../models';
import localizedRoute from '../utils/localizedRoute';
import Link from 'next/link';

const CategoryTile = ({
  category,
  siblings
}: {
  category: ICategory;
  siblings: ICategory[] | undefined;
}) => {
  const { t } = useTranslation();
  const { name, slug = '', category_name = '', count = 0 } = category;

  return (
    <div className="group relative hidden lg:block">
      <div className="aspect-w-1 aspect-h-1 h-60">
        <div className="w-full rounded-md overflow-hidden bg-modalgrey px-4 py-5 flex flex-col">
          <Link
            href={localizedRoute(
              `/shop${slug.startsWith('/') ? '' : '/'}${slug}`
            )}
            className="text-4xl font-sans text-black flex-grow mb-2"
          >
            {category_name || name}
            {/* <span className="align-top text-sm ml-1 text-black">({count})</span> */}
          </Link>
          <div className="overflow-y-auto">
            {siblings && siblings.length > 0 && (
              <>
                <h3 className="text-bold mb-2">{t('OTHER_CATEGORIES')}</h3>
                {siblings
                  .filter(({ count = 0 }) => count > 0)
                  .map(sibling => (
                    <Link
                      key={sibling.slug}
                      href={localizedRoute(
                        `/shop${sibling.slug.startsWith('/') ? '' : '/'}${
                          sibling.slug
                        }`
                      )}
                      className="block text-sm mb-1 opacity-60 font-normal"
                    >
                      {sibling.name || sibling.category_name}
                      {/* <span className="align-top text-xs ml-1 opacity-60">
                        ({sibling.count})
                      </span> */}
                    </Link>
                  ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryTile;
